import { render, staticRenderFns } from "./BinTab.vue?vue&type=template&id=c8f298c6"
import script from "./BinTab.vue?vue&type=script&lang=ts"
export * from "./BinTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports